export default function (Component) {
Component.options.__docs = "<p>By default the calendar displays the current month. You can change that by setting  <code>defaultValue</code> to a custom date value.</p>\n"
}